import { replace } from 'svelte-spa-router'
import Superagent from 'superagent'
import { adminStore } from './stores'
import StorageService from './$services/storage.service'

const { HOST_API } = _CONSTANTS_

export {
    needLogin,
    isLogin
}

async function needLogin(detail) {

    const access = StorageService.getItem('access')
    const user = StorageService.getItem('user')

    if(user)
        adminStore.set(user)

    if(access && await isSessionInvalid(access))
        return true

    if(!access || !user)
        return true

    const roles = ['admin', 'adviser', 'almacen']

    if(roles.indexOf(user.role) === -1)
        return true

    replace('#/shipments')
    return false
}

async function isLogin(detail) {

    const access = StorageService.getItem('access')
    const user = StorageService.getItem('user')

    if(user)
        adminStore.set(user)

    if(access && await isSessionInvalid(access)) {
        replace('#/')
        return false
    }

    const roles = ['admin', 'adviser', 'almacen']

    if(access && user && roles.indexOf(user.role) >= 0)
        return true

    replace('#/')
    return false
}

function isSessionInvalid(access) {
    return new Promise(resolve => {
        Superagent
            .get(`${HOST_API}/user`)
            .set('access', access)
            .end((err, res) => {
                const key = res && res.body && res.body.error && res.body.error.key

                if(key === 'accessRequired' || key === 'tokenExpired') {
                    StorageService.deleteItem('user')
                    StorageService.deleteItem('access')
                    resolve(true)
                    return
                }

                resolve(false)
            })
    })
}
